import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import MyLeftNavi from '../../../components/MyPage/MyLeftNavi';
import MyTop from '../../../components/MyPage/MyTop';
import instance from '../../../services/services';
import { MY_INFO_URL } from '../../../utils/urls';


function MyPage() {
  const location = useLocation();
  const [isTablet, setIsTablet] = useState(false);
  const [myInfo, setMyInfo] = useState(null); // 내 정보 데이터
  // 모바일 체크
  useEffect(() => {
    const checkTablet = () => {
      setIsTablet(window.innerWidth < 768);
    };
    
    checkTablet();
    window.addEventListener('resize', checkTablet);
    
    return () => window.removeEventListener('resize', checkTablet);
  }, []);
  
  // showContent 변환: 경로가 정확히 /myPage 일 때만 보이게
  const showContent = !isTablet || location.pathname ==='/myPage';

  useEffect(() => {
    const fetchMyInfo = async () => {
      try {
        const response = await instance.post(MY_INFO_URL);
        setMyInfo(response.data.data);
      } catch (error) {
        console.error("마이페이지 정보 가져오기 실패:", error);
      }
    };
    fetchMyInfo();
  }, []);


  return (
    <section className="my_section">
      {/* 마이페이지 진입페이지 */}
      
      <div className="my_page_inner">
        {/* 마이페이지 navi */}
        {showContent && (
          <MyLeftNavi myInfo={myInfo} />
        )}

        <div className="my_content">
          {/* 마이페이지 top */}
          {showContent && (
              <MyTop myInfo={myInfo} />
          )}


          {/* 마이페이지 content */}
          <div className="content_inner">
            <Outlet context={{ myInfo }}/>
          </div>
        </div>
      </div>
    </section>
  );
}

export default MyPage;